import { render, staticRenderFns } from "./MainAction.vue?vue&type=template&id=c63c6e42&scoped=true&"
import script from "./MainAction.vue?vue&type=script&lang=js&"
export * from "./MainAction.vue?vue&type=script&lang=js&"
import style0 from "./MainAction.vue?vue&type=style&index=0&id=c63c6e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63c6e42",
  null
  
)

export default component.exports